export function getFinalTotalDollars(
  productPrice,
  discountPercent,
  discountAmount
) {
  const totalPrice = parseFloat(productPrice || 0);
  if (Number.isNaN(totalPrice)) return 0;

  if (discountPercent && discountPercent !== "0.00") {
    return (
      totalPrice -
      (totalPrice * (parseFloat(discountPercent) || 0)) / 100
    );
  }

  return totalPrice - (parseFloat(discountAmount) || 0);
}

export function getFinalTotalCents(
  productPrice,
  discountPercent,
  discountAmount
) {
  const dollars = getFinalTotalDollars(
    productPrice,
    discountPercent,
    discountAmount
  );
  return Math.max(0, Math.round(dollars * 100));
}
